module.exports = __webpack_public_path__ + "ab6a5f91f4ea21ea83222725a8aced4b.svg";